module.exports = __webpack_public_path__ + "img/ng.ac423e03.jpg";